import React, { useState } from 'react';

import {
  PHONE_NUMBER_LENGTH,
  REGEX_ONLY_LETTERS_AND_NUMBERS,
  CDN_PATH, LINKS, FORM_CONSTRAINTS
} from '../constants';
import {
  MOBILE_NUMBER_10_DIGITS,
  MOBILE_NUMBER_CANT_BE_EMPTY, MOBILE_TRY_LATER,
  PASSWORD_CANT_BE_EMPTY,
  PASSWORD_LENGTH_NOT_VALID,
  PASSWORD_MUST_CONTAIN_BOTH_LETTERS_NUMBERS,
  PASSWORD_MUST_NOT_CONTAIN_PERSONAL_INFO, SURNAME_SHOULD_BE_BETWEEN,
  USERNAME_CANT_BE_EMPTY, USERNAME_SHOULD_BE_BETWEEN,
} from '../constants/errorMessagesConstants';
import {connect} from "react-redux";
import {
  getStatesAction,
  updatePasswordDataAction,
  updatePhoneDataAction,
  updateStateDataAction,
  updateUsernameDataAction,
  validateStep2Action
} from "../state/registration";
import Selectors from "../selectors";

const stateToProps = (state) => ({
  isLoading: Selectors.getIsLoadingStep2(state),
  usernameData: Selectors.getUsernameData(state),
  passwordData: Selectors.getPasswordData(state),
  emailData: Selectors.getEmailData(state),
  firstNameData: Selectors.getFirstNameData(state),
  surnameData: Selectors.getSurnameData(state),
  statesData: Selectors.getStatesData(state),
  phoneData: Selectors.getPhoneData(state),
  isLoadingStates: Selectors.getIsLoadingStates(state),
  pendingRegistrationId: Selectors.getPendingRegistrationId(state),
  otpExpiredAttempts: Selectors.getOtpExpiredAttempts(state),
});

const actionsToProps = (dispatch) => ({
  updateUsernameData: (data) => dispatch(updateUsernameDataAction(data)),
  updatePasswordData: (data) => dispatch(updatePasswordDataAction(data)),
  updateStateData: (data) => dispatch(updateStateDataAction(data)),
  updatePhoneData: (data) => dispatch(updatePhoneDataAction(data)),
  validateStep2: (payload) => dispatch(validateStep2Action(payload)),
  getStates: (payload) => dispatch(getStatesAction(payload)),
});

const useComponentDidMount = onMountHandler => {
  React.useEffect(() => {
    onMountHandler();
  }, []);
};

const SecondStep = (props) => {
  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const [usernameValue, setUsernameValue] = useState(props.usernameData.value);
  const [passwordValue, setPasswordValue] = useState(props.passwordData.value);
  const [stateValue, setStateValue] = useState(props.statesData.value);
  const [phoneValue, setPhoneValue] = useState(props.phoneData.value);

  useComponentDidMount(() => {
    window.scrollTo({top: 0, behavior: 'smooth'});

    if (props.statesData.states.length === 0) {
      props.getStates();
    }
  });

  const getClassesByStatus = (status) => {
    let classes = ' ';
    if (status === -1) {
      classes += ` registration-form__row--error registration-form__row--errorpop`;
    } else if (status === 1) {
      classes += ' registration-form__row--success';
    }

    return classes;
  };

  const checkAllStatuses = () => {
      const usernameValid = props.usernameData.status === 1;
      const passwordValid = props.passwordData.status === 1;
      const stateValid = props.statesData.status === 1;
      const phoneValid = props.phoneData.status === 1;

      return usernameValid && passwordValid && stateValid && phoneValid;
  };

  const onChangeUsername = e => {
    const username = e.target.value.trim();
    if (username.length <= FORM_CONSTRAINTS.username.max_length) {
      setUsernameValue(e.target.value.trim());
    }
  }

  const checkUsername = (event) => {
    const username = event.target.value.trim();

    if (username === '') {
      props.updateUsernameData({
        value: username,
        status: -1,
        suggestions: props.usernameData.suggestions,
        message: USERNAME_CANT_BE_EMPTY,
      });
    } else if (username.length < FORM_CONSTRAINTS.username.min_length || username.length > FORM_CONSTRAINTS.username.max_length) {
      props.updateUsernameData({
        value: username,
        status: -1,
        suggestions: props.usernameData.suggestions,
        message: USERNAME_SHOULD_BE_BETWEEN,
      });
    } else if (!REGEX_ONLY_LETTERS_AND_NUMBERS.test(username)) {
      props.updateUsernameData({
        value: username,
        status: -1,
        suggestions: props.usernameData.suggestions,
        message: "You can use letters and numbers only.",
      });
    } else {
      // Check if password was previously set and it violates some validity rules
      checkPassword(passwordValue);

      props.updateUsernameData({
        value: username,
        status: 1,
        suggestions: props.usernameData.suggestions,
        message: '',
      });
    }
  };

  const onChangePassword = e => {
    const password = e.target.value.trim();
    if (password.length <= FORM_CONSTRAINTS.password.max_length) {
      setPasswordValue(password);
      checkPassword(password)
    }
  }

  const checkPasswordEvent = event => checkPassword(event.target.value.trim());

  const checkPassword = (password) => {
    let errorCodes = [];
    let message = '';

    if (password === '') {
      props.updatePasswordData({
        value: password,
        status: -1,
        message: PASSWORD_CANT_BE_EMPTY,
        errorCodes: []
      });
    } else {
      if (password.length < FORM_CONSTRAINTS.password.min_length || password.length > FORM_CONSTRAINTS.password.max_length) {
        errorCodes.push(1);
        message = PASSWORD_LENGTH_NOT_VALID;
      }

      if (!/[0-9]/.test(password) || !/[a-zA-Z]/.test(password)) {
        errorCodes.push(2);
        message = PASSWORD_MUST_CONTAIN_BOTH_LETTERS_NUMBERS;
      }

      const firstName = props.firstNameData.value.toLowerCase();
      const surname = props.surnameData.value.toLowerCase();
      const email = props.emailData.value.toLowerCase();

      const passwordContainsPersonalData = firstName.includes(password)
          || surname.includes(password)
          || email.includes(password)
          || usernameValue.includes(password)
          || password.includes(firstName)
          || password.includes(surname)
          || password.includes(email)
          || (usernameValue !== "" && password.includes(usernameValue));

      if (passwordContainsPersonalData) {
        errorCodes.push(3);
        message = PASSWORD_MUST_NOT_CONTAIN_PERSONAL_INFO;
      }

      if (errorCodes.length > 0) {
        props.updatePasswordData({
          value: password,
          status: -1,
          message: message,
          errorCodes: errorCodes
        });
      } else {
        props.updatePasswordData({
          value: password,
          status: 1,
          message: '',
          errorCodes: []
        });
      }
    }
  };

  const toggleShowPassword = () => {
    setPasswordVisible(!isPasswordVisible);
  };

  const handleChangeState = event => {
    const state = event.target.value;
    setStateValue(state);
    checkState(state);
  };

  const checkState = (state) => {
    if (state === "") {
      props.updateStateData({
        value: '',
        status: -1,
        message: 'Select state of residence'
      });
    } else {
      props.updateStateData({
        value: state,
        status: 1,
        message: ''
      });
    }
  };

  const checkPhoneEvent = event => checkPhone(event.target.value.trim());

  const onChangePhoneEvent = e => {
    const phone = e.target.value.trim();
    if (!phone.startsWith('0') && phone.length <= 10) {
      setPhoneValue(e.target.value.trim());
    }
  }

  const checkPhone = (phone) => {
    if (phone === '') {
      props.updatePhoneData({
        value: '',
        status: -1,
        message: MOBILE_NUMBER_CANT_BE_EMPTY,
      });
    } else if (phone.length !== PHONE_NUMBER_LENGTH) {
      props.updatePhoneData({
        value: phone,
        status: -1,
        message: MOBILE_NUMBER_10_DIGITS,
      });
    } else if (phone === props.phoneData.oldValue && props.otpExpiredAttempts === true) {
      props.updatePhoneData({
        value: phone,
        status: -1,
        message: MOBILE_TRY_LATER,
      });
    } else {
      props.updatePhoneData({
        value: phone,
        status: 1,
        message: '',
      });
    }
  }

  const continueStep = () => {
    if (checkAllStatuses()) {
      const params = {
        username: props.usernameData.value,
        password: props.passwordData.value,
        mobile: `234${props.phoneData.value}`
      };

      if (props.pendingRegistrationId !== 0 && props.phoneData.value === props.phoneData.oldValue) {
        params["pendingRegistrationId"] = props.pendingRegistrationId;
      }

      props.validateStep2(params);
    }
  };

  const usernameNotificationClass = getClassesByStatus(props.usernameData.status);
  const passwordNotificationClass = getClassesByStatus(props.passwordData.status);
  const statesNotificationClass = getClassesByStatus(props.statesData.status);
  const phoneNotificationClass = getClassesByStatus(props.phoneData.status);

  return (
    <form className="registration-form">

      <div className={`registration-form__row ${usernameNotificationClass}`}>
        <label className="registration-form__label" htmlFor="username">Create a username</label>
        <input id="username" onBlur={checkUsername}
          className="registration-form__input" type="text" id="username"
          value={usernameValue}
          onChange={e => onChangeUsername(e)}
        />
        <p className="registration-form__error">
          <span className="registration-form__error-i pull-left mr5" />
          {props.usernameData.message}
        </p>
        <p className="registration-form__info-bg">You can use letters and numbers only.</p>

        <i className="registration-form__status icon-input-success" />
        <i className="registration-form__status icon-input-error" />
        {
          props.usernameData.suggestions.length > 0 && (
            <div className="registration-form__errorpop">
              <p className="registration-form__errorpop-head">Suggested Usernames:</p>
              <ul className="registration-form__errorpop-uname-ul">
                {props.usernameData.suggestions.map((suggestion) => (
                  <li
                    key={suggestion}
                    onClick={() => {
                      setUsernameValue(suggestion);
                      props.updateUsernameData({
                        value: suggestion,
                        status: 1,
                        suggestions: [],
                        message: '',
                      });
                    }}
                    className="registration-form__errorpop-uname-li"
                  >
                    {suggestion}
                  </li>
                ))}
              </ul>
            </div>
          )
        }
      </div>


      <div className={`registration-form__row ${passwordNotificationClass}`}>
        <label className="registration-form__label" htmlFor="password">Choose a password</label>
        <div className={`registration-form__pass ${!isPasswordVisible && 'registration-form__pass--shown'}`}>
          <input id="password" onBlur={checkPasswordEvent}
            className="registration-form__input registration-form__input-pass"
            type={isPasswordVisible ? 'text' : 'password'}  id="password"
            value={passwordValue}
            onChange={e => onChangePassword(e)}
          />
          <span className="registration-form__pass-vision" onClick={toggleShowPassword} />
        </div>
        <p className="registration-form__info-bg">You can use letters, numbers &amp; symbols.</p>

        <p className="registration-form__error">
          <span className="registration-form__error-i pull-left mr5" />
          {props.passwordData.message}
        </p>
        <i className="registration-form__status icon-input-success" />
        <i className="registration-form__status icon-input-error" />
        {props.passwordData.errorCodes.length > 0 &&
        <div className="registration-form__errorpop">
          <p className="registration-form__errorpop-head">Password Requirements</p>
          <ul className="registration-form__errorpop-pass-ul">
            <li className={`registration-form__errorpop-pass-li ${props.passwordData.errorCodes.includes(1) ? 'error' : 'success'}`}>8-20 Characters Long. No spaces.</li>
            <li className={`registration-form__errorpop-pass-li ${props.passwordData.errorCodes.includes(2) ? 'error' : 'success'}`}>Must Contain both letters &amp; numbers.</li>
            <li className={`registration-form__errorpop-pass-li ${props.passwordData.errorCodes.includes(3) ? 'error' : 'success'}`}>{PASSWORD_MUST_NOT_CONTAIN_PERSONAL_INFO}</li>
          </ul>
        </div>
        }
      </div>

      <div className={`registration-form__row ${statesNotificationClass}`}>
        <label className="registration-form__label" htmlFor="state">
          State
          {props.isLoadingStates &&
          <span style={{paddingLeft: '10px'}}><img src={`/${CDN_PATH}/img/loading.gif`} alt="spinner"/></span>
          }
        </label>

        <select className="registration-form__select" name="state" id="state"
                value={stateValue} onChange={handleChangeState}>
          <option value="">Select a state of residence</option>
          {props.statesData.states.map((el, ind) => (<option key={`country-${el}-${ind + 1}`} value={el}>{el}</option>))}
        </select>
        <p className="registration-form__error">
          <span className="registration-form__error-i pull-left mr5" />
          {props.statesData.message}
        </p>
        <i className="registration-form__status icon-input-success" />
        <i className="registration-form__status icon-input-error" />
      </div>

      <div className={`registration-form__row registration-form__row--mobile ${phoneNotificationClass}`}>
        <label className="registration-form__label" htmlFor="mobile">Mobile Number</label>
        <div className="d-f">
          <span className="registration-form__mobile-code">+234</span>
          <input onBlur={checkPhoneEvent} className="registration-form__input" type="number" maxLength="10" id="mobile"
                 value={phoneValue}
                 placeholder={"e.g. 8012345678"}
                 onChange={e => onChangePhoneEvent(e)}
          />
        </div>
        <p className="registration-form__error">
          <span className="registration-form__error-i pull-left mr5" />
          {props.phoneData.message}
        </p>
        <i className="registration-form__status icon-input-success" />
        <i className="registration-form__status icon-input-error" />
      </div>

      <p className="registration-form__tnc">
        <span>By creating an account you agree to accept our </span>
        <a className="visible-s" href={LINKS.terms_and_conditions} target="_blank" rel="noreferrer">{'T&C\'s,'}</a>
        <a className="hidden-s" onClick={() => { window.open(LINKS.terms_and_conditions, '_blank', 'width=1216,height=867'); }}>{'T&C\'s,'}</a>
        <span> are over 18 and are aware of our </span>
        <a className="visible-s" href={LINKS.responsible_gambling} target="_blank" rel="noreferrer"> Responsible Gaming Policy</a>
        <a className="hidden-s" onClick={() => { window.open(LINKS.responsible_gambling, '_blank', 'width=1216,height=867'); }}>Responsible Gaming Policy</a>
      </p>

      <button type="button" title="Continue"
        disabled={props.isLoading || !checkAllStatuses()}
        className={`btn-primary-s registration-form__submit ${props.isLoading ? 'btn-loader' : ''}`}
        onClick={() => continueStep()}
      >
        Continue
      </button>
    </form>
  );
}

export default connect(
    stateToProps,
    actionsToProps
)(SecondStep);
